import { css } from "@emotion/core";

export const arrowLinkContainer = css`
  margin-bottom: 40px;
  max-width: 460px;
  margin-left: auto;
  margin-right: auto;
`;
